import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import {Card} from "primereact/card";
import {Divider} from "primereact/divider";
import EntityForm from "./components/EntityForm";
import DeleteConfirmDialog from "./components/DeleteConfirmDialog";
import Lecture from "./Lecture";
import GeneralUtils from "../../../../utils/GeneralUtils";
import {ChapterService} from "../../../../service/ChapterService";
import Exam from "./CreateExam/Exam";
import Toggle from "./components/Toogle";

const defaultData = [{title: "Giriş", description: '', objectIndex: 1}];

// EntityForm için ortak props
const CHAPTER_FORM_PROPS = {
    entityName: "Bölüm",
    titlePlaceholder: "Başlık Girin",
    descriptionLabel: "Öğrenciler bu bölümün sonunda neler yapabilecek?",
    descriptionPlaceholder: "Bir Öğrenme Hedefi Gir"
};

const Chapter = (props) => {
    const {course, setCourse} = props;
    const [data, setData] = useState(course.chapterList ? course.chapterList : []);
    const [activeIndex, setActiveIndex] = useState();
    const [toggleForm, setToggleForm] = useState(false);
    const [chapterToDelete, setChapterToDelete] = useState(null);
    const service = new ChapterService();

    useEffect(() => {
        setCourse(data);
    }, [data]);

    const addChapter = (chapter) => {
        chapter.course = course.id;
        chapter.objectIndex = data.length + 1;
        service.create(chapter).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                response.course = response.course?.id;
                setData([...data, response]);
                setToggleForm(!toggleForm);
                // setCurriculum([...data, {title: title, description: description}]);
            }
        });
    };

    const updateChapter = (chapter) => {
        service.update(chapter).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                data[chapter.objectIndex-1] = {...chapter, ...response};
                setData(data);
                setActiveIndex(-1);
                // setCurriculum(data);
            }
        });
    };


    const deleteChapter = (id) => {
        service.delete(id).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && GeneralUtils.isNullOrEmpty(response.error)) {
                setData((prevData) => prevData.filter((chapter,i)=> chapter.id !== id));
                // setCurriculum(data.filter((chapter,i)=> i !== index));
                // toast.success('Kayıt Başarıyla Silindi');
            }
        });
    };


    const renderView = (chapter, index) => (
        <div className="flex flex-row align-items-center w-full gap-3 px-2 py-1 ">
            <div className="flex flex-row align-items-center gap-2 flex-1 min-w-0">
                <h6 className="m-0" style={{minWidth: "50px", fontWeight: 600}}>Bölüm {chapter.objectIndex}:</h6>
                <p className="m-0 text-overflow-ellipsis overflow-hidden white-space-nowrap flex-1 "
                   title={chapter.title}>{chapter.title}</p>
            </div>

            <div className="flex flex-row align-items-center gap-2 flex-shrink-0">
                {(index === data.length - 1) && <Button icon="pi pi-fw pi-trash" rounded text severity="danger"
                                                        onClick={() => setChapterToDelete(chapter)}/>}

                <Button icon="pi pi-fw pi-pencil" rounded text severity="secondary"
                        onClick={() => setActiveIndex(index)}/>
            </div>

        </div>
    );

    const renderEdit = (chapter, index) => (
        <EntityForm
            {...CHAPTER_FORM_PROPS}
            index={index}
            data={chapter}
            cancel={() => setActiveIndex(-1)}
            save={(chapter) => updateChapter(chapter)}
        />
    );

    const renderTitle = (chapter, index) => (
        <>
            {index !== activeIndex
                ? renderView(chapter, index)
                : renderEdit(chapter, index)
            }
            <Divider/>
        </>
    );



    return (<>{data?.sort(GeneralUtils.compareIndex).map((chapter, index) => (
            <Card key={index} title={renderTitle(chapter, index)} className="chapter-editor noshadow">
                {chapter.description &&
                    <p>
                        <span style={{minWidth: "50px", fontWeight: "600"}}>Bölüm Açıklaması: </span>{chapter.description}
                    </p>}

                <Lecture course={course} chapter={chapter} setChapter={lectureList => {data[index] = {...data[index], lectureList: lectureList, lectureCount: lectureList.length}; setData(data)}} />
                <Exam course={course} chapter={chapter} setChapter={examList => {data[index] = {...data[index], examList: examList, examCount: examList.length}; setData(data)}} />
            </Card>))}

            <Toggle
                label="Bölüm Ekle"
                visible={toggleForm}
                onHide={() => setToggleForm(!toggleForm)}
                showCard={true}
                cardClassName="chapter-form noshadow"
            >
                <EntityForm
                    {...CHAPTER_FORM_PROPS}
                    index={data.length}
                    cancel={() => setToggleForm(false)}
                    save={(chapter) => addChapter(chapter)}
                />
            </Toggle>


            <DeleteConfirmDialog
                itemToDelete={chapterToDelete}
                onHide={() => setChapterToDelete(null)}
                onConfirm={deleteChapter}
            />
        </>
    )
};

export default Chapter;
